<template>
  <div>
    <transition name="fade">
      <div class="toast-wrapper" v-show="showing">
        <span class="toast-content" v-html="message"></span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data () {
    return {
      queue: [],
      showing: false,
      duration: 3000,
      message: '',
      timeoutId: null
    }
  },
  watch: {
    queue () {
      let pending = this.queue.length
      if (pending === 0) {
        return
      }
      this.showing = true
      this.message = this.queue[0].replaceAll('\n', '<br>')

      if (pending > 1) {
        clearTimeout(this.timeoutId)
        this.showing = false
        this.timeoutId = setTimeout(() => this.queue.shift(), 0)
      } else {
        this.timeoutId = setTimeout(() => {
          this.showing = false
          this.timeoutId = null
          setTimeout(() => this.queue.shift(), 0)
        }, this.duration)
      }
    }
  }
}
</script>

<style>
.toast-wrapper{
  display: table;
  position: fixed;
  bottom: 40px;
  left: 20px;
  width: calc(100% - 40px);
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  z-index: 9999;
}

.toast-content{
  display: table-cell;
  width: 100%;
  height: 60px;
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  line-height: 1.43em;
  letter-spacing: -0.3px;
  color: #fff;
}
.fade-enter-active,
.fade-leave-active,
.fade-transition{
  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
}

/*.fade-enter,*/
/*.fade-leave,*/
/*.fade-leave-active{*/
  /*opacity: 0;*/
/*}*/
</style>
